module.exports = "/_next/static/images/91e7d0aece7fd90f1ac19093928accb5-faded-graph-icon.svg";